import React, { useState } from 'react';
import './BlogPage.css';

const posts = [
  {
    id: 1,
    tag: '🚀 Release',
    tagClass: 'tag--release',
    date: 'July 28, 2026',
    title: 'UltraCoder IDE v2.0 — The AI Revolution',
    excerpt:
      'We are thrilled to announce the biggest update in UltraCoder history. v2.0 ships with a fully redesigned AI engine, multi-model support, and real-time pair programming.',
    readTime: '5 min read',
    author: 'UltraCoder Team',
    avatar: '🧑‍💻',
  },
  {
    id: 2,
    tag: '✨ Feature',
    tagClass: 'tag--feature',
    date: 'July 15, 2026',
    title: 'Introducing AI Code Review — Ship Confidently',
    excerpt:
      'AI Code Review scans every change you make and surfaces potential bugs, security vulnerabilities, and performance bottlenecks before you hit commit.',
    readTime: '4 min read',
    author: 'Engineering',
    avatar: '⚙️',
  },
  {
    id: 3,
    tag: '🤝 Collaboration',
    tagClass: 'tag--collab',
    date: 'June 30, 2026',
    title: 'Real-Time Collaboration is Now in Beta',
    excerpt:
      'Invite teammates to your editor session and code together in real time. See cursors, edits, and AI suggestions from every collaborator instantly.',
    readTime: '3 min read',
    author: 'Product',
    avatar: '🎯',
  },
  {
    id: 4,
    tag: '🔧 Improvement',
    tagClass: 'tag--improvement',
    date: 'June 12, 2026',
    title: '30+ Language Support & Smarter Completions',
    excerpt:
      'We have expanded language support to 30+ programming languages and dramatically improved completion accuracy using our new context-aware model fine-tuned on 10B lines of code.',
    readTime: '3 min read',
    author: 'AI Research',
    avatar: '🤖',
  },
  {
    id: 5,
    tag: '🔒 Security',
    tagClass: 'tag--security',
    date: 'May 20, 2026',
    title: 'SOC 2 Type II Certified — Your Code Stays Yours',
    excerpt:
      'UltraCoder IDE has achieved SOC 2 Type II certification. We have always taken privacy seriously — this certification is our commitment made official.',
    readTime: '2 min read',
    author: 'Security Team',
    avatar: '🛡️',
  },
  {
    id: 6,
    tag: '🚀 Release',
    tagClass: 'tag--release',
    date: 'January 15, 2026',
    title: 'UltraCoder IDE v1.0 — We Are Live!',
    excerpt:
      'After months of closed beta testing with 500+ developers, UltraCoder IDE v1.0 is officially available to everyone. Start coding smarter today.',
    readTime: '4 min read',
    author: 'UltraCoder Team',
    avatar: '🧑‍💻',
  },
];

const TAGS = ['All', 'Release', 'Feature', 'Improvement', 'Security', 'Collaboration'];

const BlogPage = () => {
  const [activeTag, setActiveTag] = useState('All');
  const launchDate = process.env.REACT_APP_LAUNCH_DATE || '2024-01-15';
  const discordUrl = process.env.REACT_APP_DISCORD_URL || '#';

  const filtered =
    activeTag === 'All'
      ? posts
      : posts.filter((p) => p.tag.toLowerCase().includes(activeTag.toLowerCase()));

  return (
    <div className="blog-page">
      {/* Hero */}
      <section className="blog-page__hero">
        <div className="blog-page__hero-bg" />
        <div className="blog-page__container">
          <div className="blog-page__badge">
            <span>📰</span> Blog &amp; Changelog
          </div>
          <h1 className="blog-page__title">
            What's new in <br />
            <span className="blog-page__title-gradient">UltraCoder IDE</span>
          </h1>
          <p className="blog-page__subtitle">
            Updates, feature launches, and insights from the team. <br />
            UltraCoder has been shipping since <strong>{launchDate}</strong>.
          </p>
        </div>
      </section>

      {/* Filter tabs */}
      <section className="blog-page__filters">
        <div className="blog-page__container">
          <div className="blog-page__filter-row">
            {TAGS.map((tag) => (
              <button
                key={tag}
                className={`blog-page__filter-btn ${activeTag === tag ? 'blog-page__filter-btn--active' : ''}`}
                onClick={() => setActiveTag(tag)}
              >
                {tag}
              </button>
            ))}
          </div>
        </div>
      </section>

      {/* Posts */}
      <section className="blog-page__posts">
        <div className="blog-page__container">
          <div className="blog-page__grid">
            {filtered.map((post) => (
              <article key={post.id} className="blog-card">
                <div className="blog-card__header">
                  <span className={`blog-card__tag ${post.tagClass}`}>{post.tag}</span>
                  <span className="blog-card__date">{post.date}</span>
                </div>
                <h2 className="blog-card__title">{post.title}</h2>
                <p className="blog-card__excerpt">{post.excerpt}</p>
                <div className="blog-card__footer">
                  <div className="blog-card__author">
                    <span className="blog-card__avatar">{post.avatar}</span>
                    <span className="blog-card__author-name">{post.author}</span>
                  </div>
                  <span className="blog-card__read-time">{post.readTime}</span>
                </div>
              </article>
            ))}
          </div>

          {filtered.length === 0 && (
            <div className="blog-page__empty">
              <span>📭</span>
              <p>No posts in this category yet. Check back soon!</p>
            </div>
          )}
        </div>
      </section>

      {/* Subscribe strip */}
      <section className="blog-page__subscribe">
        <div className="blog-page__container">
          <div className="blog-page__subscribe-box">
            <h3>Stay in the loop</h3>
            <p>Get notified about new releases and features in our Discord community.</p>
            <a href={discordUrl} target="_blank" rel="noreferrer" className="blog-page__discord-btn">
              💬 Join our Discord
            </a>
          </div>
        </div>
      </section>
    </div>
  );
};

export default BlogPage;